export enum DecisionType {
    connect = 'connect',
    pass = 'pass',
    undo = 'undo',
    withdraw = 'withdraw',
    invite = 'invite',
    remove = 'remove',
}
